import { SELFSERVE_API } from '~/lib/constants';

export function getApiPath(profile: string, path: string): string {
  // return `https://selfserve-edge.serverless.p2g.systems/${SettingsCache.profile}`;
  return `${SELFSERVE_API}/${profile}${path}`;
}

export function getCreateEnquiryApiPath(path: string): string {
  return `${SELFSERVE_API}/${path}`;
}
